<template>
    <div class="">
        <install-wizard-card>
            <template #top-header>
                Physical Installation
            </template>
            <template #top-content>
                Install your meters following our tutorials!
            </template>

            <template #body-summary>
                Now it's time to install your meters and probes!  Below is a list of your points by meter and installation instructions.

                <br/>Once you finish installing a probe and see a new check-in, click confirm install.

                <div class="w-full md:w-1/3 mt-4">
                    <floating-input
                        id="search"
                        label="Search By Name Or Serial Number"
                        v-model:value="search"
                    ></floating-input>
                </div>
            </template>

            <template #body-action>
              <template v-for="(device, index) in physicalDevicesList">
                <install-wizard-well    v-if="shouldShow(device, index)"
                                        :key="index"
                                        :expanded="!finishedDevices[index]"
                                        collapsed-bg="bg-green-50">
                  <template #well-header-left>
                    <div class="text-sm font-medium leading-5 text-blue-600 truncate">{{index}}</div>
                    <div class="flex flex-wrap items-center mt-2 text-sm leading-5 text-gray-500">
                      <div v-for="point in device"
                           class="w-full">
                        <!--                                <span :class="needsSaved(point.meter.ID) ? 'icon-sync-crossed' : 'icon-check'" class="w-2 lnr"></span>-->
                        {{ point.name }}
                      </div>
                    </div>
                  </template>
                  <template #well-header-center>
                    <div>
                      <div class="text-sm leading-5 text-gray-900">
                        {{getMeterType(device)}}
                      </div>
                      <!--                                        <div class="flex items-center mt-2 text-sm leading-5 text-gray-500">-->
                      <!--                                            Pharmacy-->
                      <!--                                        </div>-->
                    </div>
                  </template>
                  <template #well-content>
                    <ul class="grid grid-cols-1 mt-4 gap-6 lg:grid-cols-2">
                      <install-wizard-physical-install-card
                        v-for="point in device"
                        :key="point.ID"
                        :point="point"
                        :area-zones="areaZones"
                        :is-finished="finishedPoints[point.ID]"
                      ></install-wizard-physical-install-card>
                    </ul>
                    <div    class="border-t border-gray-200">
                      <div class="flex -mt-px">
                        <div class="flex flex-1 w-0 border-gray-200">

                          <!--                                    <a      class="my-2 text-blue-700 hover:text-blue-700 focus:text-blue-700 focus:no-underline"-->
                          <a class="relative inline-flex py-3 items-center justify-center flex-1 w-0 border-2
                                                border-blue-200 text-md leading-5 font-md font-sans rounded-md
                                                text-blue-700 bg-white-600 hover:bg-blue-200 focus:outline-none
                                                focus:ring-blue-200 focus:border-blue-400 active:bg-blue-300
                                                rounded-bl-lg cursor-pointer focus:z-10 focus:no-underline"
                             :href="quickStartGuideUrl(device)"
                             target="_blank">
                            <span class="lnr icon-wrench pr-2"></span>
                            Install Instructions
                          </a>
                        </div>
                      </div>
                    </div>
                  </template>
                </install-wizard-well>
              </template>
            </template>

            <template #bottom-header>
                Done installing meters?
            </template>
            <!--            <template #bottom-button-text></template>-->
        </install-wizard-card>
    </div>
</template>

<script>
    import InstallWizardCard from "./InstallWizardCard";
    import InstallWizardWell from "@/components/InstallWizard/InstallWizardWell";
    import InstallWizardPhysicalInstallCard from "@/components/InstallWizard/InstallWizardPhysicalInstallCard";
    import FloatingInput from "../elements/FloatingInput";
    import _ from "lodash";

    export default {
        name: "InstallWizardPhysicalInstall",
        components: {FloatingInput, InstallWizardWell, InstallWizardCard, InstallWizardPhysicalInstallCard},
        props: {
            physicalDevicesList: Object,
            areaZones: Object,
            installedPoints: Object,
        },
        data(){
            return {
                search: '',
                finishedDevices: {},
                finishedPoints: {},
            }
        },
        created() {
            // Is the point already installed
            Object.keys(this.physicalDevicesList).forEach((deviceSerial) => {
                let points = this.physicalDevicesList[deviceSerial]
                let pointsFinished = false
                points.forEach((point) => {
                    this.finishedPoints[point.ID] = this.installedPoints[point.ID] ?? false
                    pointsFinished = pointsFinished || this.finishedPoints[point.ID]
                })
                this.finishedDevices[deviceSerial] = pointsFinished
            })
        },
        mounted() {
        },
        methods: {
            shouldShow(device, deviceSerial) {
                if (_.isNil(device) || _.isNil(deviceSerial)) {
                    return false
                }

                let search = this.search.toLowerCase()
                if (deviceSerial.toLowerCase().indexOf(search) !== -1) {
                    return true
                }

                let searchFound = false
                _.forEach(device, meter => {
                    if (_.isNil(meter) || _.isNil(meter.AliasSerial) && _.isNil(meter.SNISerial)) {
                        return
                    }
                    if (meter.AliasSerial.toLowerCase().indexOf(search) !== -1) {
                        searchFound = true
                    }
                    else if (meter.SNISerial.toLowerCase().indexOf(search) !== -1) {
                        searchFound = true
                    }
                    else if (meter.meter.Name.toLowerCase().indexOf(search) !== -1) {
                        searchFound = true
                    }
                })

                return searchFound
            },
            getMeterType(device) {
                if (device.length > 0) {
                    if (device[0].settingsArray != null && device[0].settingsArray.device_type != null) {
                        return device[0].settingsArray.device_type;
                    }
                }
                return '';
            },
            getDeviceType(points) {
                let typeNotFound = 'Unknown Device Type'
                if (points.length === 0) {
                    return typeNotFound
                }

                // Get the Device Type Below using the first point.  All of the points on the device array are on the same device.
                let point = points[0]
                if (_.isNil(point) || _.isNil(point.settingsArray)) {
                    return typeNotFound
                }

                if (! ('device_type' in point.settingsArray)) {
                    return typeNotFound
                }

                return point.settingsArray['device_type']
            },
            quickStartGuideUrl(device) {
                let uriPrefix = 'https://support.sonicu.com/'
                let deviceType = this.getDeviceType(device)
                if (deviceType.includes('SoniShield Duo')) {
                    uriPrefix += 'sonishield-duo-quick-start-guide'
                }
                else if (deviceType.includes('SoniShield View')) {
                    // TODO. Check on A Quick start guide for the SoniShield View.
                    uriPrefix += 'sonishield-duo-quick-start-guide'
                }
                else if (deviceType.includes('Gateway')) {
                    uriPrefix += 'mvp-gateway-quick-start-guide'
                }
                else if (deviceType.includes('S-Series')) {
                    uriPrefix += 's-series-quick-start/activation-guide'
                }
                else {
                    uriPrefix += 'mvp-410/440-quick-start-guide'
                }

                return uriPrefix

            },
        },
        computed: {
        },
    }
</script>

<style scoped>

</style>